export const GET_QR_CODES_REQUEST = "GET_QR_CODES_REQUEST";
export const GET_QR_CODES_SUCCESS = "GET_QR_CODES_SUCCESS";
export const GET_QR_CODES_FAILURE = "GET_QR_CODES_FAILURE";

export const CREATE_QR_CODE_REQUEST = "CREATE_QR_CODE_REQUEST";
export const CREATE_QR_CODE_SUCCESS = "CREATE_QR_CODE_SUCCESS";
export const CREATE_QR_CODE_FAILURE = "CREATE_QR_CODE_FAILURE";
